import React from 'react';
import { Box, Hidden } from '@mui/material';

// ********************************************************************************
// Made with css for maximum flexibility in case of changes in the future.
// SEE: https://bennettfeely.com/clippy/
export const VerticalDivider = () => (
  <Hidden mdDown>
    <Box
      component="figure"
      position="absolute"
      top={0}
      left={0}
      zIndex={1}
      bgcolor="white"
      sx={{ clipPath: 'polygon(70% 0, 100% 0, 30% 100%, 0 100%)' }}
      height="344px"
      width="220px"
    />
    <Box
      component="figure"
      position="absolute"
      top={0}
      left={65}
      zIndex={10}
      bgcolor="#EF60A3"
      sx={{ clipPath: 'polygon(70% 0, 100% 0, 30% 100%, 0 100%)' }}
      height="344px"
      width="220px"
    />
  </Hidden>
);
